var Handlebars = require("../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_8.9.1/lib/node_modules/@core/macys-cli/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"container\">\n  <h4 class=\"stores-no-stores-msg\"> Sorry, no stores found. Please try another location</h4>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_ce_v2/package/src/templates/partials/storesNotFound.hbs
// module id = 379
// module chunks = 0